import { useEffect } from "react";

const SITE_NAME = "Tip Top Property";
const ORIGIN = (typeof window !== "undefined" && window.location?.origin) || "";

function setMeta(name, content, attr = "name") {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Lightweight SEO hook — sets <title>, meta description, OG/Twitter cards and canonical
 * for the current SPA route.
 */
export function useSeo({ title, description, path = "/", lang = "nl", image, noindex = false } = {}) {
  useEffect(() => {
    const full = title ? `${title} — ${SITE_NAME}` : SITE_NAME;
    document.title = full;
    document.documentElement.lang = lang;

    setMeta("description", description);
    if (noindex) setMeta("robots", "noindex, nofollow");
    setMeta("og:title", full, "property");
    setMeta("og:description", description, "property");
    setMeta("og:type", "website", "property");
    setMeta("og:site_name", SITE_NAME, "property");
    setMeta("og:locale", lang === "nl" ? "nl_BE" : lang === "fr" ? "fr_BE" : "en_US", "property");
    if (image) setMeta("og:image", image, "property");

    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", full);
    setMeta("twitter:description", description);
    if (image) setMeta("twitter:image", image);

    if (ORIGIN) setLink("canonical", `${ORIGIN}${path}`);
  }, [title, description, path, lang, image, noindex]);
}
